/* AmourLinen bedding PDP helpers: money format, country, and how bed sizes are named.
   Used by assets/kd-pdp-bedding.js (loaded from snippets/kd-pdp-bedding.liquid). Split out of that snippet in Oct 2026
   because the Shopify upload limit is 16 KB per file. */
window.ALB = (function () {
  var KEYMAP = { US: 'us', CA: 'us', GB: 'uk', IE: 'uk', DE: 'de', AT: 'de', CH: 'ch', FR: 'fr', BE: 'fr', LU: 'fr', AU: 'au', NZ: 'au' };
  var INCH = { US: 1, CA: 1 };
  var NAMES = { DE: 'Germany', US: 'United States', GB: 'United Kingdom', FR: 'France', AU: 'Australia', CH: 'Switzerland', CA: 'Canada', AT: 'Austria', ALL: 'all countries' };
  var CHEVRON = '<svg width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true"><path d="M1 1l6 6 6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.replace(/"/g, '&quot;'); }

  /* the shop's money format, learned from a probe amount that Liquid formatted (1,234,567.89 in the shop's style) */
  function parseProbe(raw) {
    var s = String(raw == null ? '' : raw).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    var m = s.match(/\d[\d\s.,  ']*\d/);
    if (!m) return { pre: '', suf: '', dec: '.', th: '', decimals: 2 };
    var num = m[0];
    var last = Math.max(num.lastIndexOf('.'), num.lastIndexOf(','));
    var dec = '', decimals = 0;
    if (last > -1 && num.length - last - 1 === 2) { dec = num.charAt(last); decimals = 2; }
    var rest = decimals ? num.slice(0, last) : num;
    var tm = rest.match(/\d([^\d])\d{3}/);
    return { pre: s.slice(0, m.index), suf: s.slice(m.index + num.length), dec: dec, th: tm ? tm[1] : '', decimals: decimals };
  }
  function makeMoney(f) {
    return function (cents) {
      var amount = cents / 100;
      var str = f.decimals ? amount.toFixed(2) : String(Math.round(amount));
      var parts = str.split('.');
      var whole = f.th ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.th) : parts[0];
      return f.pre + whole + (f.decimals ? f.dec + parts[1] : '') + f.suf;
    };
  }

  function storedCountry(serverCc) {
    try {
      var q = new URLSearchParams(window.location.search).get('size_country');
      if (q) { localStorage.setItem('al_size_country', q.toUpperCase()); return q.toUpperCase(); }
      return localStorage.getItem('al_size_country') || serverCc;
    } catch (e) { return serverCc; }
  }

  /* ---------- sizes: names, local or not ----------
     Country view (e.g. Germany): local name on the left, local measurement (cm, or in for US/CA) on the right.
       A size with no local name shows only its measurement.
     "Show all sizes" (in a dropdown, or chosen in Change, or a country we have no names for):
       name if the size has one (the local one, else the name used where it is standard, with the country
       in brackets), and cm AND inches together on the right. A size with no name anywhere shows cm + in only. */
  var KEY_ORDER = ['us', 'uk', 'de', 'fr', 'ch', 'au'];
  var KEY_TAG = { us: 'US', uk: 'UK', de: 'DE', fr: 'FR', ch: 'CH', au: 'AU' };
  function allMode(cc) { return cc === 'ALL' || !KEYMAP[cc]; }
  function foreignName(e) {
    var std = e.std || [], k, n;
    for (n = 0; n < std.length; n++) { k = KEYMAP[std[n]]; if (k && e[k]) return e[k] + ' (' + KEY_TAG[k] + ')'; }
    for (n = 0; n < KEY_ORDER.length; n++) { k = KEY_ORDER[n]; if (e[k]) return e[k] + ' (' + KEY_TAG[k] + ')'; }
    return '';
  }
  function partsOf(v, cc, expanded) {
    var e = v.e, key = KEYMAP[cc];
    if (!e) return { name: v.n, dims: [] };
    var local = (!allMode(cc) && key && e[key]) ? e[key] : '';
    if (!allMode(cc) && !expanded) {
      var dim = INCH[cc] ? e['in'] : e.cm;
      if (local) return { name: local, dims: dim ? [dim] : [] };
      return { name: dim || v.n, dims: [] };
    }
    var both = (INCH[cc] ? [e['in'], e.cm] : [e.cm, e['in']]).filter(function (x) { return !!x; });
    var nm = local || foreignName(e);
    if (nm) return { name: nm, dims: both };
    return { name: both[0] || v.n, dims: both.slice(1) };
  }
  function areaOf(v) {
    var m = String((v.e && v.e.cm) || v.n || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
    return m ? parseInt(m[1], 10) * parseInt(m[2], 10) : 1e9;
  }
  function isLocal(v, cc) {
    if (cc === 'ALL' || !KEYMAP[cc]) return true;
    var e = v.e;
    if (e) return (e.std || []).indexOf(cc) > -1 || !!e[KEYMAP[cc]];
    return INCH[cc] ? !v.m : v.m;
  }
  return { KEYMAP: KEYMAP, INCH: INCH, NAMES: NAMES, CHEVRON: CHEVRON, esc: esc, parseProbe: parseProbe, makeMoney: makeMoney, storedCountry: storedCountry, allMode: allMode, partsOf: partsOf, areaOf: areaOf, isLocal: isLocal };
})();